// Get the current theme from localStorage or default to 'light'
const getCurrentTheme = () => {
  return localStorage.getItem('theme') || 'light';
};

// Set the theme in localStorage and update the data-theme attribute
const setTheme = (theme) => {
  localStorage.setItem('theme', theme);
  document.documentElement.setAttribute('data-theme', theme);
};

// Toggle between light and dark themes
const toggleTheme = () => {
  const currentTheme = getCurrentTheme();
  const newTheme = currentTheme === 'light' ? 'dark' : 'light';
  setTheme(newTheme);
  return newTheme;
};

// Initialize theme on page load
const initializeTheme = () => {
  const theme = getCurrentTheme();
  setTheme(theme);
};

export { getCurrentTheme, setTheme, toggleTheme, initializeTheme }; 